// Copyright (c) Bentley Systems
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./report-web-vitals";
import { ConfigManager } from "./Helpers/config-manager";
import { BrowserAuthorizationClient } from "@itwin/browser-authorization";
import { ITwinLayout } from "./ITwinLayout";

const redirectUri = ConfigManager.getBaseUrl();

if (redirectUri.pathname === window.location.pathname) {
  BrowserAuthorizationClient.handleSignInCallback().catch((error) =>
    console.error("Auth callback failed", error), // eslint-disable-line no-console -- runs before React mounts; no UI available
  );
} else {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );
  root.render(<ITwinLayout />);

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
